module.exports = __webpack_public_path__ + "static/media/helengeli-11.58ef6517.jpg";